<template>
  <div
    :class="{
      show:
        (this.loading || this.counter < 100) &&
        $route.name !== 'Login' &&
        $route.name !== 'Error',
    }"
    class="background"
  >
    <div class="loader">
      <AixamTvComponent />
      <div class="loading">
        <div
          :style="
            'transform: translate(-50%, -50%) scaleX(' + counter / 100 + ');'
          "
          class="progress"
        ></div>
      </div>
      <div class="counter">{{ counter }}%</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import AixamTvComponent from "@/components/AixamTvComponent.vue";
import { useMainStore } from "@/store";

export default {
  name: "LoaderComponent",
  components: { AixamTvComponent },
  data() {
    return {
      interval: null,
      timeout: 15,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      loading: (store) => store.loading,
      counter: (store) => store.counter,
    }),
  },
  watch: {
    loading() {
      if (this.loading) {
        // this.load();
      }
    },
  },
  mounted() {
    // this.load();
  },
  methods: {
    load() {
      this.resetCounter();
      this.interval = setInterval(() => {
        this.incrementCounter();

        if (this.counter > 99) {
          clearInterval(this.interval);
        }
      }, this.timeout);
    },
    ...mapActions(useMainStore, ["incrementCounter", "resetCounter"]),
  },
};
</script>

<style lang="scss" scoped>
.background {
  background: url("@/assets/images/bg.jpg") no-repeat top left;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 500ms ease-in-out;
  opacity: 0;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &.show {
    opacity: 1;
    visibility: visible;
  }
}

.loading {
  background: $white;
  height: 20px;
  width: 400px;
  border-radius: 10px;
  position: relative;
  border: 2.5px solid $white;
  overflow: hidden;
}

.progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: left;
  background: $red;
  height: 100%;
  width: 100%;
  border-radius: 15px;
}

.counter {
  color: $white;
  text-align: center;
  margin-top: 5px;
}
</style>
